export default __webpack_public_path__ + "f5e39988bdcbcd955ca93f24c81b8f38.png";